import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { setDisabled } from "../store/common/uiSlice";
import { logoutUser } from "../services/auth.services";

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loggingOut, setLoggingOut] = useState(false);

  const logout = async () => {
    dispatch(setDisabled(true));
    setLoggingOut(true);
    // logoutUser never throws; a failed server call still logs out locally.
    await logoutUser();
    localStorage.clear();
    setLoggingOut(false);
    dispatch(setDisabled(false));
    navigate("/Login");
  };

  return { logout, loggingOut };
};
